/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExercisePrerequisiteDTO
 */
export interface ExercisePrerequisiteDTO {
    /**
     * 
     * @type {string}
     * @memberof ExercisePrerequisiteDTO
     */
    exerciseId: string;
    /**
     * 
     * @type {number}
     * @memberof ExercisePrerequisiteDTO
     */
    minReps?: number;
    /**
     * 
     * @type {number}
     * @memberof ExercisePrerequisiteDTO
     */
    minDurationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ExercisePrerequisiteDTO
     */
    minSets?: number;
    /**
     * 
     * @type {number}
     * @memberof ExercisePrerequisiteDTO
     */
    minLoadKg?: number;
}

/**
 * Check if a given object implements the ExercisePrerequisiteDTO interface.
 */
export function instanceOfExercisePrerequisiteDTO(value: object): value is ExercisePrerequisiteDTO {
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    return true;
}

export function ExercisePrerequisiteDTOFromJSON(json: any): ExercisePrerequisiteDTO {
    return ExercisePrerequisiteDTOFromJSONTyped(json, false);
}

export function ExercisePrerequisiteDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExercisePrerequisiteDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'exerciseId': json['exerciseId'],
        'minReps': json['minReps'] == null ? undefined : json['minReps'],
        'minDurationSeconds': json['minDurationSeconds'] == null ? undefined : json['minDurationSeconds'],
        'minSets': json['minSets'] == null ? undefined : json['minSets'],
        'minLoadKg': json['minLoadKg'] == null ? undefined : json['minLoadKg'],
    };
}

export function ExercisePrerequisiteDTOToJSON(json: any): ExercisePrerequisiteDTO {
    return ExercisePrerequisiteDTOToJSONTyped(json, false);
}

export function ExercisePrerequisiteDTOToJSONTyped(value?: ExercisePrerequisiteDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exerciseId': value['exerciseId'],
        'minReps': value['minReps'],
        'minDurationSeconds': value['minDurationSeconds'],
        'minSets': value['minSets'],
        'minLoadKg': value['minLoadKg'],
    };
}

